<template>
  <div class="input-field" :style="customStyle">
    <input
      :id="id"
      ref="inputfield"
      v-model="inputText"
      class="inputfield"
      :class="{
        inputfield_error: error
      }"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      :required="required"
      :disabled="disabled"
      @blur="onBlur"
      @keyup.enter="onEnter"
    />
    <span v-if="showHide" @click="toggle">{{ text }}</span>
    <p v-if="error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    id: [String, Number],
    value: [String, Number],
    placeholder: String,
    type: String,
    name: String,
    required: String,
    customStyle: String,
    capitalized: Boolean,
    disabled: Boolean,
    showHide: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    focus: false,
    error: null,
    text: 'Show'
  }),
  computed: {
    inputText: {
      get() {
        return this.value;
      },
      set(val) {
        let v = val;
        if (this.capitalized) {
          v = val.charAt(0).toUpperCase() + val.slice(1);
        }
        this.$emit('input', v);
        this.$emit('change', v);
      }
    }
  },
  watch: {
    inputText() {
      this.error = null;
    }
  },
  methods: {
    setError(error) {
      this.error = error;
    },
    onBlur() {
      setTimeout(() => {
        this.focus = false;
      }, 300);
    },
    onEnter(e) {
      this.$emit('enter', e);
      if (this.next && typeof this.next === 'function') {
        this.next(e);
      }
    },
    setFocus() {
      this.$refs.inputfield.focus();
    },
    toggle() {
      if (this.text === 'Show') {
        this.text = 'Hide';
        this.$refs.inputfield.type = 'text';
      } else {
        this.text = 'Show';
        this.$refs.inputfield.type = 'password';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-field {
  position: relative;
  .inputfield {
    position: relative;
    width: 100%;
    height: 70px;
    background: #ffffff;
    border-radius: 4px;
    color: $colorTextDark;
    border: none;
    outline: none !important;

    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    padding: 0 25px;
    letter-spacing: -0.04em;

    &::placeholder {
      color: $colorPlaceholder;
    }
  }

  .inputfield_error {
    border: 0.5px solid $colorRed;
  }

  span {
    position: absolute;
    top: 25px;
    right: 25px;
    cursor: pointer;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #606c82;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: $colorRed;
    margin: 0;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .inputfield {
      height: 50px;
      font-size: 16px;
      line-height: 26px;
    }

    span {
      top: 15px;
      right: 15px;
      font-size: 14px;
      line-height: 20px;
    }

    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
